var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Transform, Type } from "class-transformer";
import { IsOptional, IsBoolean, IsNotEmpty, IsString, IsNumber, IsArray, ValidateNested, IsEnum, IsObject, IsUUID, } from "class-validator";
export function ToBoolean() {
    return Transform(function (_a) {
        var value = _a.value;
        if (typeof value === "boolean")
            return value;
        if (typeof value === "string") {
            return value.toLowerCase() === "true";
        }
        return undefined;
    });
}
/**
 * Enum representing privacy levels for response DTOs.
 */
export var PrivacyLevelEnum;
(function (PrivacyLevelEnum) {
    /**
     * Non-sensitive data intended for unrestricted public access.
     * Example: Public announcements, contact information for city services.
     */
    PrivacyLevelEnum[PrivacyLevelEnum["PUBLIC"] = 0] = "PUBLIC";
    /**
     * Data accessible only to authenticated users.
     * Example: Personal dashboard, tax status, or application progress.
     */
    PrivacyLevelEnum[PrivacyLevelEnum["REGISTERED"] = 1] = "REGISTERED";
    /**
     * Sensitive personal or identifiable information requiring special authorization.
     * Example: Service history, detailed complaint filings, or employee reviews.
     */
    PrivacyLevelEnum[PrivacyLevelEnum["RESTRICTED"] = 2] = "RESTRICTED";
    /**
     * Highly sensitive data with strict access controls.
     * Example: Medical records, financial data, or law enforcement reports.
     */
    PrivacyLevelEnum[PrivacyLevelEnum["CONFIDENTIAL"] = 3] = "CONFIDENTIAL";
    /**
     * Data stripped of personal identifiers for privacy compliance.
     * Example: Anonymized health statistics or service utilization reports.
     */
    PrivacyLevelEnum[PrivacyLevelEnum["ANONYMIZED"] = 4] = "ANONYMIZED";
})(PrivacyLevelEnum || (PrivacyLevelEnum = {}));
export var SensibilityLevelEnum;
(function (SensibilityLevelEnum) {
    SensibilityLevelEnum[SensibilityLevelEnum["NOT_APPLICABLE"] = 0] = "NOT_APPLICABLE";
    SensibilityLevelEnum[SensibilityLevelEnum["PERSONAL"] = 1] = "PERSONAL";
    SensibilityLevelEnum[SensibilityLevelEnum["SENSITIVE"] = 2] = "SENSITIVE";
    SensibilityLevelEnum[SensibilityLevelEnum["ANONYMIZED"] = 3] = "ANONYMIZED";
})(SensibilityLevelEnum || (SensibilityLevelEnum = {}));
var EntityWithPermission = /** @class */ (function () {
    function EntityWithPermission() {
    }
    __decorate([
        IsUUID()
    ], EntityWithPermission.prototype, "id", void 0);
    __decorate([
        IsString()
    ], EntityWithPermission.prototype, "name", void 0);
    __decorate([
        IsEnum(["read", "write"])
    ], EntityWithPermission.prototype, "access", void 0);
    return EntityWithPermission;
}());
export { EntityWithPermission };
var Permissions = /** @class */ (function () {
    function Permissions() {
    }
    __decorate([
        IsOptional(),
        IsArray(),
        ValidateNested({ each: true }),
        Type(function () { return EntityWithPermission; })
    ], Permissions.prototype, "users", void 0);
    __decorate([
        IsOptional(),
        IsArray(),
        ValidateNested({ each: true }),
        Type(function () { return EntityWithPermission; })
    ], Permissions.prototype, "roles", void 0);
    __decorate([
        IsOptional(),
        IsArray(),
        ValidateNested({ each: true }),
        Type(function () { return EntityWithPermission; })
    ], Permissions.prototype, "groups", void 0);
    return Permissions;
}());
export { Permissions };
var BaseOptions = /** @class */ (function () {
    function BaseOptions() {
    }
    __decorate([
        IsOptional(),
        IsBoolean(),
        ToBoolean()
    ], BaseOptions.prototype, "required", void 0);
    __decorate([
        IsOptional(),
        IsEnum(PrivacyLevelEnum)
    ], BaseOptions.prototype, "accessLevel", void 0);
    __decorate([
        IsOptional(),
        IsEnum(SensibilityLevelEnum)
    ], BaseOptions.prototype, "sensibilityLevel", void 0);
    __decorate([
        IsOptional(),
        ValidateNested(),
        Type(function () { return Permissions; })
    ], BaseOptions.prototype, "permissions", void 0);
    __decorate([
        IsOptional(),
        IsString()
    ], BaseOptions.prototype, "documentation", void 0);
    __decorate([
        IsOptional(),
        IsBoolean(),
        ToBoolean()
    ], BaseOptions.prototype, "enableEdition", void 0);
    return BaseOptions;
}());
export { BaseOptions };
var FieldInputOptions = /** @class */ (function (_super) {
    __extends(FieldInputOptions, _super);
    function FieldInputOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        IsOptional(),
        IsString()
    ], FieldInputOptions.prototype, "label", void 0);
    __decorate([
        IsOptional(),
        IsBoolean(),
        ToBoolean()
    ], FieldInputOptions.prototype, "readOnly", void 0);
    __decorate([
        IsOptional(),
        IsString()
    ], FieldInputOptions.prototype, "tooltip", void 0);
    __decorate([
        IsOptional(),
        IsObject()
    ], FieldInputOptions.prototype, "schema", void 0);
    __decorate([
        IsOptional(),
        IsBoolean()
    ], FieldInputOptions.prototype, "plugins", void 0);
    return FieldInputOptions;
}(BaseOptions));
export { FieldInputOptions };
var FieldGroupOptions = /** @class */ (function (_super) {
    __extends(FieldGroupOptions, _super);
    function FieldGroupOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        IsOptional(),
        IsString()
    ], FieldGroupOptions.prototype, "tooltip", void 0);
    return FieldGroupOptions;
}(BaseOptions));
export { FieldGroupOptions };
var FieldRuleOptions = /** @class */ (function (_super) {
    __extends(FieldRuleOptions, _super);
    function FieldRuleOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        IsOptional(),
        IsObject()
    ], FieldRuleOptions.prototype, "schema", void 0);
    return FieldRuleOptions;
}(BaseOptions));
export { FieldRuleOptions };
// Structure Fields
var TitleOptions = /** @class */ (function (_super) {
    __extends(TitleOptions, _super);
    function TitleOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        IsNotEmpty(),
        IsString()
    ], TitleOptions.prototype, "title", void 0);
    __decorate([
        IsOptional(),
        IsString()
    ], TitleOptions.prototype, "tooltip", void 0);
    return TitleOptions;
}(BaseOptions));
export { TitleOptions };
var SubtitleOptions = /** @class */ (function (_super) {
    __extends(SubtitleOptions, _super);
    function SubtitleOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        IsNotEmpty(),
        IsString()
    ], SubtitleOptions.prototype, "html", void 0);
    __decorate([
        IsOptional(),
        IsString()
    ], SubtitleOptions.prototype, "tooltip", void 0);
    return SubtitleOptions;
}(BaseOptions));
export { SubtitleOptions };
// Input Fields
var InputOptions = /** @class */ (function (_super) {
    __extends(InputOptions, _super);
    function InputOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        IsOptional(),
        IsString()
    ], InputOptions.prototype, "type", void 0);
    __decorate([
        IsOptional(),
        IsString()
    ], InputOptions.prototype, "mask", void 0);
    __decorate([
        IsOptional(),
        IsNumber()
    ], InputOptions.prototype, "decimalScale", void 0);
    __decorate([
        IsOptional(),
        IsString()
    ], InputOptions.prototype, "placeholder", void 0);
    __decorate([
        IsOptional(),
        IsBoolean(),
        ToBoolean()
    ], InputOptions.prototype, "autoFocus", void 0);
    return InputOptions;
}(FieldInputOptions));
export { InputOptions };
var TextAreaOptions = /** @class */ (function (_super) {
    __extends(TextAreaOptions, _super);
    function TextAreaOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        IsOptional(),
        IsString()
    ], TextAreaOptions.prototype, "placeholder", void 0);
    __decorate([
        IsOptional(),
        IsBoolean(),
        ToBoolean()
    ], TextAreaOptions.prototype, "autoFocus", void 0);
    __decorate([
        IsOptional(),
        IsBoolean(),
        ToBoolean()
    ], TextAreaOptions.prototype, "code", void 0);
    return TextAreaOptions;
}(FieldInputOptions));
export { TextAreaOptions };
var SelectOptions = /** @class */ (function (_super) {
    __extends(SelectOptions, _super);
    function SelectOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        IsOptional(),
        IsString()
    ], SelectOptions.prototype, "placeholder", void 0);
    __decorate([
        IsOptional(),
        IsArray(),
        ValidateNested({ each: true }),
        Type(function () { return Item; })
    ], SelectOptions.prototype, "items", void 0);
    return SelectOptions;
}(FieldInputOptions));
export { SelectOptions };
var RadioOptions = /** @class */ (function (_super) {
    __extends(RadioOptions, _super);
    function RadioOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        IsOptional(),
        IsArray(),
        ValidateNested({ each: true }),
        Type(function () { return Item; })
    ], RadioOptions.prototype, "items", void 0);
    return RadioOptions;
}(FieldInputOptions));
export { RadioOptions };
var CheckboxOptions = /** @class */ (function (_super) {
    __extends(CheckboxOptions, _super);
    function CheckboxOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        IsOptional(),
        IsArray(),
        ValidateNested({ each: true }),
        Type(function () { return Item; })
    ], CheckboxOptions.prototype, "items", void 0);
    return CheckboxOptions;
}(FieldInputOptions));
export { CheckboxOptions };
var UploadOptions = /** @class */ (function (_super) {
    __extends(UploadOptions, _super);
    function UploadOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        IsOptional(),
        IsString()
    ], UploadOptions.prototype, "dir", void 0);
    __decorate([
        IsOptional(),
        IsBoolean(),
        ToBoolean()
    ], UploadOptions.prototype, "multiple", void 0);
    __decorate([
        IsOptional(),
        IsBoolean(),
        ToBoolean()
    ], UploadOptions.prototype, "gallery", void 0);
    __decorate([
        IsOptional(),
        IsNumber()
    ], UploadOptions.prototype, "maxSize", void 0);
    __decorate([
        IsOptional(),
        IsArray(),
        IsString({ each: true })
    ], UploadOptions.prototype, "supportedExtensions", void 0);
    return UploadOptions;
}(FieldInputOptions));
export { UploadOptions };
var MapOptions = /** @class */ (function (_super) {
    __extends(MapOptions, _super);
    function MapOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        IsOptional(),
        IsArray(),
        ValidateNested({ each: true }),
        Type(function () { return Layer; })
    ], MapOptions.prototype, "layers", void 0);
    __decorate([
        IsOptional(),
        IsString()
    ], MapOptions.prototype, "height", void 0);
    __decorate([
        IsOptional(),
        IsString()
    ], MapOptions.prototype, "width", void 0);
    __decorate([
        IsOptional(),
        IsBoolean(),
        ToBoolean()
    ], MapOptions.prototype, "table", void 0);
    __decorate([
        IsOptional(),
        IsBoolean(),
        ToBoolean()
    ], MapOptions.prototype, "zoomControl", void 0);
    __decorate([
        IsOptional(),
        IsBoolean(),
        ToBoolean()
    ], MapOptions.prototype, "hideHeader", void 0);
    __decorate([
        IsOptional(),
        IsString()
    ], MapOptions.prototype, "source", void 0);
    return MapOptions;
}(FieldInputOptions));
export { MapOptions };
// Group
var PresetOptions = /** @class */ (function (_super) {
    __extends(PresetOptions, _super);
    function PresetOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        IsOptional(),
        IsString()
    ], PresetOptions.prototype, "key", void 0);
    return PresetOptions;
}(FieldGroupOptions));
export { PresetOptions };
var BlockOptions = /** @class */ (function (_super) {
    __extends(BlockOptions, _super);
    function BlockOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        IsOptional(),
        IsString()
    ], BlockOptions.prototype, "label", void 0);
    __decorate([
        IsOptional(),
        IsBoolean(),
        ToBoolean()
    ], BlockOptions.prototype, "card", void 0);
    __decorate([
        IsOptional(),
        IsBoolean(),
        ToBoolean()
    ], BlockOptions.prototype, "open", void 0);
    __decorate([
        IsOptional(),
        IsEnum(["step", "block"])
    ], BlockOptions.prototype, "layout", void 0);
    __decorate([
        IsOptional(),
        IsBoolean(),
        ToBoolean()
    ], BlockOptions.prototype, "toggle", void 0);
    __decorate([
        IsOptional(),
        IsBoolean(),
        ToBoolean()
    ], BlockOptions.prototype, "hideEditMenu", void 0);
    __decorate([
        IsOptional(),
        IsBoolean(),
        ToBoolean()
    ], BlockOptions.prototype, "hideCardBorder", void 0);
    return BlockOptions;
}(FieldGroupOptions));
export { BlockOptions };
// Group
var ArrayOptions = /** @class */ (function (_super) {
    __extends(ArrayOptions, _super);
    function ArrayOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        IsString(),
        IsNotEmpty()
    ], ArrayOptions.prototype, "label", void 0);
    __decorate([
        IsOptional(),
        IsBoolean(),
        ToBoolean()
    ], ArrayOptions.prototype, "readOnly", void 0);
    __decorate([
        IsOptional(),
        IsBoolean(),
        ToBoolean()
    ], ArrayOptions.prototype, "hideHeader", void 0);
    __decorate([
        IsOptional(),
        IsNumber()
    ], ArrayOptions.prototype, "columns", void 0);
    __decorate([
        IsOptional(),
        IsEnum(["table"])
    ], ArrayOptions.prototype, "layout", void 0);
    __decorate([
        IsOptional(),
        IsString()
    ], ArrayOptions.prototype, "width", void 0);
    return ArrayOptions;
}(FieldGroupOptions));
export { ArrayOptions };
var TableOptions = /** @class */ (function (_super) {
    __extends(TableOptions, _super);
    function TableOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        IsString(),
        IsNotEmpty()
    ], TableOptions.prototype, "label", void 0);
    __decorate([
        IsOptional(),
        IsBoolean(),
        ToBoolean()
    ], TableOptions.prototype, "readOnly", void 0);
    __decorate([
        IsOptional(),
        IsNumber(),
        Type(function () { return Number; })
    ], TableOptions.prototype, "columns", void 0);
    __decorate([
        IsOptional(),
        IsString()
    ], TableOptions.prototype, "width", void 0);
    __decorate([
        IsNotEmpty()
    ], TableOptions.prototype, "table", void 0);
    return TableOptions;
}(FieldGroupOptions));
export { TableOptions };
// Logic
var LinkOptions = /** @class */ (function (_super) {
    __extends(LinkOptions, _super);
    function LinkOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LinkOptions;
}(FieldRuleOptions));
export { LinkOptions };
var IntegrationOptions = /** @class */ (function (_super) {
    __extends(IntegrationOptions, _super);
    function IntegrationOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        IsOptional(),
        IsBoolean(),
        ToBoolean()
    ], IntegrationOptions.prototype, "log", void 0);
    return IntegrationOptions;
}(FieldRuleOptions));
export { IntegrationOptions };
// utils
var Item = /** @class */ (function () {
    function Item() {
    }
    __decorate([
        IsNotEmpty(),
        IsString()
    ], Item.prototype, "label", void 0);
    __decorate([
        IsNotEmpty()
    ], Item.prototype, "value", void 0);
    return Item;
}());
var Layer = /** @class */ (function () {
    function Layer() {
    }
    __decorate([
        IsNotEmpty(),
        IsString()
    ], Layer.prototype, "title", void 0);
    __decorate([
        IsArray(),
        ValidateNested({ each: true }),
        Type(function () { return LayerProperty; })
    ], Layer.prototype, "properties", void 0);
    __decorate([
        IsNotEmpty(),
        IsString()
    ], Layer.prototype, "color", void 0);
    __decorate([
        IsNotEmpty(),
        IsString()
    ], Layer.prototype, "key", void 0);
    return Layer;
}());
var LayerProperty = /** @class */ (function () {
    function LayerProperty() {
    }
    __decorate([
        IsNotEmpty(),
        IsString()
    ], LayerProperty.prototype, "key", void 0);
    __decorate([
        IsNotEmpty(),
        IsString()
    ], LayerProperty.prototype, "label", void 0);
    __decorate([
        IsNotEmpty(),
        IsBoolean()
    ], LayerProperty.prototype, "includeOnPopUp", void 0);
    return LayerProperty;
}());
